import { component_tool, utils_tool } from '../../../tool';
let { WizModal, WizSurveyAudience, WizTypography, WizRow } = component_tool;
let { $$, checkStrLength } = utils_tool;
import React from 'react'
import HighSet from "@/containers/common/highSet";

//配置项
let componentName = 'series'

const columns = [
  {
    name: "id",
    formItem: {
      type: "hidden"
    }
  },
  {
    title: "名称",
    name: "name",
    dataIndex: "name",
    searchItem: {},
    tableItem: {
      width:"200px",
    },
  },
  {
    title: "分类",
    name: "seriesCategoryName",
    dataIndex: "seriesCategoryName",
    tableItem: {
      width:"300px",
    },
  },
  {
    title: "分类",
    name: "seriesCategoryIds",
    dataIndex: "seriesCategoryIds",
    searchItem: {
      type: 'treeselect',
      allowClear:true,
      dict: {
        wizReplaceData: "treeData",
        defalutType: []
      },
    }
  },
  {
    title: "类型",
    name: "type",
    dataIndex: "type",
    dict: [
      {code: 0, codeName: '系列'},
      {code: 1, codeName: '课程组'}
    ],
    searchItem: {
      type: "select",
    },
    tableItem: {}
  },
  {
    title: "状态",
    name: "state",
    dataIndex: "state",
    tableItem: {},
    dict: [
      { code: 1, codeName: "有效" },
      { code: 0, codeName: "无效" }
    ],
    searchItem: {
      type: "select"
    },
  },
  {
    title: "课程数量",
    name: "programCount",
    dataIndex: "programCount",
    tableItem: {},
  },
  {
    title: "关注人数",
    name: "followCount",
    dataIndex: "followCount",
    tableItem: {},
  }

];

const templateConfig = {
  mainProps: {},
  content: {
    name: "WizTableList",
    params: {
      columns,
      searchBarProps: {
        buttonSort: ['add',"export","exportStudyDetail","exportStudyReport",'import'],
        buttons: [
          {
            key: "add",
            custom: true,
            params: { icon: "plus", children: "新增", type: "primary"},
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/series/seriesList/seriesDetailAdd"
              }
            }

          },
          {
            key: 'export',
            custom: true,
            params: { icon: 'export', children: '导出', type: 'export'},
            customOnClick: {
              key: 'action',
              params: {
                apiKey: "export",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                return { ...filters }
              }
            }
          },
          {
            key: 'exportStudyDetail',
            custom: true,
            params: { icon: 'export', children: '系列化学习明细导出', type: 'export'},
            customOnClick: {
              key: 'action',
              params: {
                apiKey: "getFileInfoByFileId",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                if (rows && rows.length && rows.length == 1) {
                  let detailFileId ;
                  rows.forEach(d => {
                    detailFileId = d.detailFileId;
                  })
                  filters = {fileId:detailFileId}
                  return {...filters}
                } else {
                  WizModal.confirm({
                    title: '请选择一条数据进行导出',
                    onOk: () => {},
                    onCancel() {}
                  })
                }
              }
            },
            recordChangeParams: ({record, rows}) => {
              let disabled = 0;
              if (rows && rows instanceof Array && rows.length > 0) {
                rows.forEach(item => {
                  let {state,detailFileId} = item;
                  if ((state != null && state === 0) || detailFileId===null || detailFileId==='' || detailFileId===undefined ) {
                    disabled = 1;
                  }
                })
              } else {
                disabled = 1;
              }
              return {disabled: disabled}
            }
          },
          {
            key: 'exportStudyReport',
            custom: true,
            params: { icon: 'export', children: '系列化学习统计导出', type: 'export'},
            customOnClick: {
              key: 'action',
              params: {
                apiKey: "getFileInfoByFileId",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                if (rows && rows.length && rows.length == 1) {
                  let reportFileId;
                  rows.forEach(d => {
                    reportFileId = d.reportFileId
                  })
                  filters = {fileId:reportFileId}
                  return {...filters}
                } else {
                  WizModal.confirm({
                    title: '请选择一条数据进行导出',
                    onOk: () => {},
                    onCancel() {}
                  })
                }
              }
            },
            recordChangeParams: ({record, rows}) => {
              let disabled = 0;
              if (rows && rows instanceof Array && rows.length > 0) {
                rows.forEach(item => {
                  let {state,reportFileId} = item;
                  if ((state != null && state === 0) || reportFileId===null || reportFileId==='' || reportFileId===undefined ) {
                    disabled = 1;
                  }
                })
              } else {
                disabled = 1;
              }
              return {disabled: disabled}
            }
          },
          {
            key: "import",
            custom: true,
            params: { children: "导入"},
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/series/seriesList/seriesFileImport"
              }
            }
          },

        ]
      },
      modalFormProps: {},
      dataTableProps: {
        rowKey: "id",
        selectType: "checkbox",
        isScroll: true,
        loading: false
      },
      rowOperateSort: ['look','update', 'enableOrDisable','exportFollowRecord',"contentManagement",'contentClassificationManagement', 'advancedSet'],
      rowOperateView: [
        {
          key: "look",
          custom: true,
          params: { children: "查看"},
          customOnClick: {
            key: "jumpPage",
            params: {
              key: "push",
              pathname: "/series/seriesList/seriesInfo"
            }
          }
        },
        {
          key: "update",
          custom: true,
          params: { children: "编辑"},
          customOnClick: {
            key: "jumpPage",
            params: {
              key: "push",
              pathname: "/series/seriesList/seriesDetailUpd"
            }
          }
        },
        {
          key: "enableOrDisable",
          custom: true,
          params: { children: "禁用/启用" },
          textFormat: {
            recordKey: 'state',
            dirt: {  1: '禁用', 0: "启用" }
          },
          customOnClick: {
            key: "action",
            params: {
              apiKey: "updateStatus",
              apiParams: {}
            },
            formatParams: (rows, record, filters, callback) => {
              const content = `您确定要${
                (record['state'] === 0 ? "启用" : "禁用")}？`;
              WizModal.confirm({
                title: '注意', content,
                onOk: () => {
                  callback && callback({
                    state: record['state'] === 1 ? 0 : 1,
                    id: record['id']
                  })
                },
                onCancel() {
                }
              });
              return null
            }
          }
        },
        {
          key: "exportFollowRecord",
          custom: true,
          params: { children: "导出关注记录" },
          customOnClick: {
            key: "action",
            params: {
              apiKey: "exportFollowRecord",
              apiParams: {}
            },
            formatParams: (rows, record, filters, callback) => {
              return { id:record.id}
            }
          }
        },
        {
          key: "contentManagement",
          custom: true,
          params: { children: "内容管理"},
          customOnClick: {
            key: "jumpPage",
            params: {
              key: "push",
              pathname: "/series/seriesList/seriesContentList"
            }
          }
        },
        {
          key: "contentClassificationManagement",
          custom: true,
          params: { children: "内容分类管理"},
          customOnClick: {
            key: "jumpPage",
            params: {
              key: "push",
              pathname: "/series/seriesList/seriesProgram"
            }
          }
        },
        {
          key: 'advancedSet',
          custom: true,
          params: {children: '高级设置'},
          customOnClick: {
            key: 'modal',
            params: {
              modalParams: {
                title: '高级设置',
                bordered: true,
                footer: null,
                destroyOnClose: true,
                diy: (e) => {
                  return <>
                    <HighSet data={{record: e.record,bizType: 25}}
                             changeModal={e.changeModal}
                    />
                  </>
                },
                width: 950
              },
            }
          },
          recordChangeParams: ({record, rows}) => {
            let disabled = false
            if (record && record['state'] !== 1) {
              disabled = true
            }
            return {disabled}
          }
        },
      ],
      commonOperate: {}
    }
  }
};

const apis = {
  list: {
    path: `${componentName}/getListByPage`,
    payload: {
      key: `${componentName}@listByPage`,
      apiParams: {
        isShowNewType: true
      }
    }
  },
  updateStatus: {
    path: `${componentName}/updateStatus`,
    payload: {
      key: `${componentName}@updateStatus`,
      apiParams: {}
    }
  },
  export: {
    path: `${componentName}/export`,
    payload: {
      key: `${componentName}@export`,
      apiParams: {
        isShowNewType: true
      }
    }
  },
  exportFollowRecord: {
    path: `${componentName}/exportFollowRecord`,
    payload: {
      key: `${componentName}@exportFollowRecord`,
      apiParams: {}
    }
  },
  treeData: {
    path: `questionType/normalNodeList`,
    payload: {
      key: `questionType@treeData`,
      apiParams: {type:7,state:1}
    }
  },
  exportStudyDetail: {
    path: `${componentName}/exportSeriesStudyDetail`,
    payload: {
      key: `${componentName}@exportSeriesStudyDetail`,
      apiParams: {}
    }
  },
  exportStudyReport: {
    path: `${componentName}/exportSeriesStudyReport`,
    payload: {
      key: `${componentName}@exportSeriesStudyReport`,
      apiParams: {}
    }
  },
  getFileInfoByFileId: {
    path: `ossUpload/getFileInfoByFileId`,
    payload: {
      key: `ossUpload@getFileInfoByFileId`,
      apiParams: {}
    }
  }

}


let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list','treeData'],
    needLoading: true,
    ...args
  }
};

export { reduxTemplateCofig, templateConfig };
